// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lzxQ","colBig":"styles_colBig__185Vy","colSmall":"styles_colSmall__33KqW"};